import React, { useState, useEffect } from 'react';
import MobileFilterCollapse, { searchSummary } from '../common/form/MobileFilterCollapse';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

const ManufacturingSearchBox = ({ formik, onReset }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values?.searchStrtDt, formik.values?.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangeThisYear = () => {
    const firstDay = dayjs().startOf('year');
    const lastDay = dayjs().endOf('year');
    formik.setFieldValue('searchStrtDt', firstDay);
    formik.setFieldValue('searchEndDt', lastDay);
  };

  const handleChangeLastYear = () => {
    const firstDay = dayjs().subtract(1, 'year').startOf('year');
    const lastDay = dayjs().subtract(1, 'year').endOf('year');
    formik.setFieldValue('searchStrtDt', firstDay);
    formik.setFieldValue('searchEndDt', lastDay);
  };

  return (
    <MobileFilterCollapse summary={searchSummary(formik.values)}>
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
          p: 2,
          backgroundColor: '#f5f5f5',
          borderRadius: 1,
        }}
      >
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label="매출 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchStrtDt"
              name="searchStrtDt"
              value={searchStrtDt}
              onChange={(newValue) => {
                setSearchStrtDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchStrtDt');
              }}
              slotProps={{
                textField: {
                  variant: 'standard',
                  error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                  helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ mx: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label="매출 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchEndDt"
              name="searchEndDt"
              value={searchEndDt}
              onChange={(newValue) => {
                setSearchEndDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchEndDt');
              }}
              slotProps={{
                textField: {
                  variant: 'standard',
                  error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                  helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ mr: 2 }}>
          <Button variant="outlined" color="info" onClick={handleChangeThisYear}>
            금년
          </Button>
          <Button
            variant="outlined"
            color="info"
            onClick={handleChangeLastYear}
            sx={{ mx: 1 }}
          >
            작년
          </Button>
        </Box>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '25ch' },
            }}
          >
            <TextField
              variant="standard"
              select
              id="manufacturingStatus"
              name="manufacturingStatus"
              label="제조상태"
              value={formik.values.manufacturingStatus}
              onChange={formik.handleChange}
            >
              <MenuItem value="">전체</MenuItem>
              <MenuItem value="제조전">제조전</MenuItem>
              <MenuItem value="설계중">설계중</MenuItem>
              <MenuItem value="생산중">생산중</MenuItem>
              <MenuItem value="QC중">QC중</MenuItem>
              <MenuItem value="완료">완료</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
            >
              <MenuItem value="projectNo">프로젝트번호</MenuItem>
              <MenuItem value="projectName">프로젝트명</MenuItem>
              <MenuItem value="customerName">매출처명</MenuItem>
              <MenuItem value="manager">담당자</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              id="searchWords"
              name="searchWords"
              label="검색어"
              value={formik.values.searchWords}
              onChange={formik.handleChange}
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>
          <Box>
            <Button type="submit" color="info" variant="contained">
              검색
            </Button>
            <Button
              color="inherit"
              variant="outlined"
              onClick={onReset}
              sx={{ ml: 1 }}
            >
              초기화
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
    </MobileFilterCollapse>
  );
};

export default ManufacturingSearchBox;
